<template>
  <div class="flex min-h-screen flex-col">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <AppFooter v-if="shouldShowFooter" />
    <!-- <AppToast /> -->
    <CommerceToast :toast-list="toastList" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

const { toastList } = useToast()
const DESKTOP_BREAKPOINT = 1024

const route = useRoute()

const FOOTER_HIDDEN_ON_MOBILE_ROUTES = ['service-id', 'order-id']

const isDesktopViewport = ref(false)

const isFooterRestrictedRoute = computed(() => FOOTER_HIDDEN_ON_MOBILE_ROUTES.includes(String(route.name)))

const shouldShowFooter = computed(() => {
  if (isFooterRestrictedRoute.value) {
    return isDesktopViewport.value
  }
  return true
})

const updateViewportState = () => {
  isDesktopViewport.value = window.innerWidth >= DESKTOP_BREAKPOINT
}

onMounted(() => {
  updateViewportState()
  window.addEventListener('resize', updateViewportState)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateViewportState)
})
</script>
